import {
  fetchDataflowBuilderWizardLayoutAnnotationsValues,
  hideDataflowBuilderWizardLayoutAnnotationsForm,
  readDataflowBuilderWizardLayoutAnnotationsHierarchicalCodelists,
  readDataflowBuilderWizardLayoutAnnotationsItemsPage,
  resetDataflowBuilderWizardLayoutAnnotationsForm,
  resetDataflowBuilderWizardLayoutAnnotationsItemsPage,
  resetDataflowBuilderWizardLayoutAnnotationsValues,
  showDataflowBuilderWizardLayoutAnnotationsForm,
  submitDataflowBuilderWizardLayoutAnnotationsForm
} from "./actions";
import {connect} from "react-redux";
import {compose} from "redux";
import {translate} from 'react-i18next';
import {readDataflowBuilderWizardDsdForLayoutAnnotations} from "../actions";
import Layout from "../../../../../components/annotations-form/Layout";

const mapStateToProps = state => ({
  dataflow: state.scenes.dataManager.dataflowBuilder.shared.dataflow,
  isFormVisible: state.scenes.dataManager.dataflowBuilder.components.wizard.components.layoutAnnotations.isFormVisible,
  dsdForLayoutAnnotations: state.scenes.dataManager.dataflowBuilder.shared.dsdForLayoutAnnotations,
  itemsPage: state.scenes.dataManager.dataflowBuilder.components.wizard.components.layoutAnnotations.itemsPage,
  valuesForLayoutAnnotations: state.scenes.dataManager.dataflowBuilder.components.wizard.components.layoutAnnotations.valuesForLayoutAnnotations,
  hierarchicalCodelists: state.scenes.dataManager.dataflowBuilder.components.wizard.components.layoutAnnotations.hierarchicalCodelists,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onFormShow: () => dispatch(showDataflowBuilderWizardLayoutAnnotationsForm()),
  onFormHide: () => dispatch(hideDataflowBuilderWizardLayoutAnnotationsForm()),
  onFormSubmit: annotations => dispatch(submitDataflowBuilderWizardLayoutAnnotationsForm(annotations)),
  onFormReset: () => dispatch(resetDataflowBuilderWizardLayoutAnnotationsForm()),
  fetchDsdForLayoutAnnotations: dsdTriplet => dispatch(readDataflowBuilderWizardDsdForLayoutAnnotations(dsdTriplet)),
  fetchItemsPage: (
    {
      codelistTriplet,
      language,
      pageNum,
      pageSize,
      searchText,
      filters,
      sortCol,
      sortByDesc
    },
    dsdComponentName,
    selectedCodes
  ) => dispatch(readDataflowBuilderWizardLayoutAnnotationsItemsPage({
      codelistTriplet,
      language,
      pageNum,
      pageSize,
      searchText,
      filters,
      sortCol,
      sortByDesc
    },
    ownProps.cubeId,
    ownProps.colNames,
    "ID_" + dsdComponentName,
    ownProps.filterStr,
    selectedCodes
  )),
  resetItemsPage: () => dispatch(resetDataflowBuilderWizardLayoutAnnotationsItemsPage()),
  fetchValuesForLayoutAnnotations: colName => dispatch(fetchDataflowBuilderWizardLayoutAnnotationsValues(
    ownProps.cubeId,
    ownProps.colNames,
    "ID_" + colName,
    ownProps.filterStr
  )),
  resetValuesForLayoutAnnotations: () => dispatch(resetDataflowBuilderWizardLayoutAnnotationsValues()),
  fetchHierarchicalCodelists : () => dispatch(readDataflowBuilderWizardLayoutAnnotationsHierarchicalCodelists()), 
});

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
)(Layout);